<script setup lang="ts">
import InformationContainer from '@components/ui/auto-reserve&gift-card&index/InformationContainer.vue';
import { ReserveType } from '@utils/itinerary';

const { setReserveType } = useSearchFormStore();
useServerHead({
    link: [
        {
            rel: 'canonical',
            href: 'https://mrbilit.com/hotel',
        },
    ],
});

onMounted(() => setReserveType(ReserveType.Hotel));
definePageMeta({
    breadcrumbs: JSON.stringify([
        { title: 'مِستربلیط', link: '/' },
        { title: 'رزرو هتل', link: '$routePath' },
    ]),
});
</script>

<template>
    <InformationContainer />
</template>
